<div #containerTemplate class="scroll-adapter__container">
    <div #contentTemplate class="scroll-adapter__content" [class.scroll-adapter__stretch]="stretch"><ng-content /></div>
</div>
<span #leftArrow class="scroll-left scroll-adapter__arrow--hidden" (click)="scrollLeft()">
    <ds-arrow direction="left" variant="strong" inverse="false" [size]="size" />
</span>
<span #rightArrow class="scroll-right scroll-adapter__arrow--hidden" (click)="scrollRight()">
    <ds-arrow direction="right" variant="strong" inverse="false" [size]="size" />
</span>
